import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from "@angular/common";

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.css'],
    standalone: true
})
export class PrivacyComponent implements OnInit {

  constructor(private scroller: ViewportScroller) { }

  ngOnInit(): void {
  }

  scrollToArticle(article: string) {
    this.scroller.setOffset([0,100]);
    this.scroller.scrollToAnchor(article);
  }
}
